[
    {
        "display": "true",
        "ui_columnname": "reportDate",
        "db_columnname": "reportDate",
        "datatype": "String",
        "mappingkey": "reportDate",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "rsmsStatus",
        "db_columnname": "rsmsStatus",
        "datatype": "String",
        "mappingkey": "rsmsStatus",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "groupName",
        "db_columnname": "groupName",
        "datatype": "String",
        "mappingkey": "groupName",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "errorCodeList",
        "db_columnname": "errorCodeList",
        "datatype": "String",
        "mappingkey": "errorCodeList",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "createDate",
        "db_columnname": "createDate",
        "datatype": "String",
        "mappingkey": "createDate",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "updateDate",
        "db_columnname": "updateDate",
        "datatype": "String",
        "mappingkey": "updateDate",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "lastUpdatedBy",
        "db_columnname": "lastUpdatedBy",
        "datatype": "String",
        "mappingkey": "lastUpdatedBy",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
    "display": "true",
    "ui_columnname": "actionType",
    "db_columnname": "actionType",
    "datatype": "String",
    "mappingkey": "actionType",
    "dropdown": "NO",
    "disabled": "true",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "errorROEID",
    "db_columnname": "errorROEID",
    "datatype": "String",
    "mappingkey": "errorROEID",
    "dropdown": "NO",
    "disabled": "true",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "firmROEID",
    "db_columnname": "firmROEID",
    "datatype": "String",
    "mappingkey": "firmROEID",
    "dropdown": "NO",
    "disabled": "true",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "type",
    "db_columnname": "type",
    "datatype": "String",
    "mappingkey": "type",
    "dropdown": "NO",
    "disabled": "true",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "CATReporterIMID",
    "db_columnname": "CATReporterIMID",
    "datatype": "String",
    "mappingkey": "CATReporterIMID",
    "dropdown": "NO",
    "disabled": "true",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "orderKeyDate",
    "db_columnname": "orderKeyDate",
    "datatype": "String",
    "mappingkey": "orderKeyDate",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "orderID",
    "db_columnname": "orderID",
    "datatype": "String",
    "mappingkey": "orderID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "optionID",
    "db_columnname": "optionID",
    "datatype": "String",
    "mappingkey": "optionID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "priorOrderKeyDate",
    "db_columnname": "priorOrderKeyDate",
    "datatype": "String",
    "mappingkey": "priorOrderKeyDate",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "priorOrderID",
    "db_columnname": "priorOrderID",
    "datatype": "String",
    "mappingkey": "priorOrderID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "originatingIMID",
    "db_columnname": "originatingIMID",
    "datatype": "String",
    "mappingkey": "originatingIMID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "eventTimestamp",
    "db_columnname": "eventTimestamp",
    "datatype": "String",
    "mappingkey": "eventTimestamp",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "manualFlag",
    "db_columnname": "manualFlag",
    "datatype": "Boolean",
    "mappingkey": "manualFlag",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "electronicTimestamp",
    "db_columnname": "electronicTimestamp",
    "datatype": "String",
    "mappingkey": "electronicTimestamp",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "initiator",
    "db_columnname": "initiator",
    "datatype": "String",
    "mappingkey": "initiator",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "price",
    "db_columnname": "price",
    "datatype": "Float",
    "mappingkey": "price",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "quantity",
    "db_columnname": "quantity",
    "datatype": "Float",
    "mappingkey": "quantity",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "minQty",
    "db_columnname": "minQty",
    "datatype": "Float",
    "mappingkey": "minQty",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "leavesQty",
    "db_columnname": "leavesQty",
    "datatype": "Float",
    "mappingkey": "leavesQty",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "priorUnlinked",
    "db_columnname": "priorUnlinked",
    "datatype": "String",
    "mappingkey": "priorUnlinked",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "nextUnlinked",
    "db_columnname": "nextUnlinked",
    "datatype": "String",
    "mappingkey": "nextUnlinked",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "timeInForce",
    "db_columnname": "timeInForce",
    "datatype": "String",
    "mappingkey": "timeInForce",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "netPrice",
    "db_columnname": "netPrice",
    "datatype": "Float",
    "mappingkey": "netPrice",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}]